import React, { useState, useEffect, useRef } from "react";
import { useField, Field, useFormik } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import {
  UPLOAD_ICON,
  WORD_ICON,
  TEXT_ICON,
  PDF_ICON,
  EXCEL_ICON,
} from "../../../assets/js/image";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledcEditor from "@ckeditor/ckeditor5-build-decoupled-document";

import * as Yup from "yup";
import "./style.css";

const MultiSelectField = (props) => {
  return (
    <>
      <Select
        isMulti
        {...props.field}
        options={props.options.map((item) => ({
          value: item.optionName,
          label: item.optionName,
        }))}
        onChange={(option, action) => {
          props.form.setFieldTouched(props.field.name, true, true);
          props.form.setFieldValue(
            props.field.name,
            option ? option.map((x) => x.value) : [],
            true
          );
        }}
        closeMenuOnSelect={true}
        value={
          props.field.value
            ? props.field.value.map((x) => ({ value: x, label: x }))
            : []
        }
        isInvalid={props.meta.touched && props.meta.error}
        errorText={true}
        styles={{
          control: (styles) =>
            props.meta.touched && props.meta.error
              ? { ...styles, borderColor: "#dc3545" }
              : { ...styles },
        }}
      />
    </>
  );
};

const RichTextField = (props) => {
  const { field, form } = props;
  const { value = "", name } = field;
  const [editorState, setEditorState] = useState(value);

  const onEditorStateChange = (e, editorState) => {
    let data = editorState.getData();
    setEditorState(data);

    const isTemplateVariable = (variable) => {
      const a = variable.split("_");
      return a.length === 1 || (variable.indexOf("_") !== -1 && a.length === 2);
    };

    if (data) {
      const templateVariables =
        form.getFieldMeta("templateVariables").value || [];
      let hasPlaceHolderErr = false;

      const editorTemplateVariables = [];
      let dataTemp = data;
      while (true) {
        if (dataTemp.indexOf("{") === -1 || dataTemp.indexOf("}") === -1) {
          break;
        }
        if (dataTemp.indexOf("{") >= -1) {
          var c = dataTemp.substring(
            dataTemp.indexOf("{") + 1,
            dataTemp.indexOf("}")
          );
          editorTemplateVariables.push(c);
          dataTemp = dataTemp.substr(dataTemp.indexOf("}") + 1);
        }
      }
      editorTemplateVariables.forEach((variable) => {
        if (isTemplateVariable(variable)) {
          const st = variable.split("_")[0];
          if (!templateVariables.toString().includes(`${st}`)) {
            hasPlaceHolderErr = true;
          }
        }
      });
      templateVariables.forEach((variable) => {
        if (isTemplateVariable(variable)) {
          const tmpVariableList = variable.split("_");
          const tmpVariable = `{${tmpVariableList[0]}}`;
          if (
            (tmpVariableList.length === 1 && !data.includes(tmpVariable)) ||
            (tmpVariableList.length === 2 &&
              !data.includes(`${tmpVariableList[0]}`))
          ) {
            hasPlaceHolderErr = true;
          }
        }
      });

      if (hasPlaceHolderErr) {
        const placeHolderErrTxt = templateVariables
          .map((x) => "${" + x + "}")
          .toString();
        form.setFieldTouched(name, true, false);
        form.setFieldValue(name, data, false);
        form.setFieldError(
          name,
          `Email body should contain ${templateVariables.length} placeholders as ${placeHolderErrTxt}.`
        );
      } else {
        form.setFieldTouched(name, true, true);
        form.setFieldValue(name, data, true);
      }
    } else {
      form.setFieldTouched(name, true, true);
      form.setFieldValue(name, data, true);
    }
  };

  return (
    <>
      <div id="EditorToolbar"></div>
      <CKEditor
        editor={DecoupledcEditor}
        data={editorState}
        onChange={onEditorStateChange}
        onReady={(editor) => {
          document.getElementById("EditorToolbar") &&
            document
              .getElementById("EditorToolbar")
              .appendChild(editor.ui.view.toolbar.element);
        }}
        config={{
          removePlugins: [
            "BlockQuote",
            "Image",
            "ImageToolbar",
            "ImageUpload",
            "EasyImage",
            "ImageCaption",
            "ImageResize",
            "ImageStyle",
            "CKFinderUploadAdapter",
            "CKFinder",
            "CloudServices",
            "MediaEmbed",
          ],
          toolbar: {
            shouldNotGroupWhenFull: true,
            toolbarLocation: "top",
          },
        }}
      />
    </>
  );
};

const FileUploadControl = (props) => {
  const { field, form } = props;
  const { value = "", name } = field;

  const [hightlight, setHightlight] = useState(false);
  const [files, setFiles] = useState(null);
  const [fileListItem, setFileListItem] = useState(null);

  const fileInputRef = useRef(null);
  const fileBrowseRef = useRef(null);

  useEffect(() => {
    if (value && value.length > 0) {
      setFileListItem(value.map((x) => x));
    }
  }, [value]);

  const openFileDialog = () => {
    fileInputRef.current.click();
  };

  const updateFileListItem = (newFileObjectArr) => {
    let existingItemList = fileListItem || [];

    newFileObjectArr.forEach((item) => {
      const existRow = existingItemList.find(
        (rec) => rec.fileName === item.name
      );
      if (!existRow) {
        existingItemList.push({
          fileName: item.name,
          donwloadUrl: "",
          fileSize: `${item.size}`,
        });
      }
    });

    setFileListItem([...existingItemList]);
    form.setFieldValue(name, [...existingItemList]);
  };

  const onFilesAdded = (e) => {
    e.preventDefault();
    const fileEventList = e?.target?.files || [];
    const fileArray = fileListToArray(fileEventList);

    let existingFiles = files ? [...files] : [];

    fileArray.forEach((x) => {
      const fndRow = existingFiles.find((item) => item.name === x.name);
      if (!fndRow) {
        existingFiles.push(x);
      }
    });

    setFiles([...existingFiles]);
    form.setFieldValue("filesToUploadList", [...existingFiles]);

    updateFileListItem([...existingFiles]);
  };

  const onDragOver = (event) => {
    event.preventDefault();
    setHightlight(true);
  };

  const onDragLeave = (event) => {
    setHightlight(false);
  };

  const onDrop = (event) => {
    event.preventDefault();
    const fileEvents = event.dataTransfer.files;

    const fileArray = fileListToArray(fileEvents);
    let existingFiles = files ? [...files] : [];

    fileArray.forEach((x) => {
      existingFiles.push(x);
    });

    setFiles([...existingFiles]);
    form.setFieldValue("filesToUploadList", [...existingFiles]);

    setHightlight(false);
    updateFileListItem([...existingFiles]);
  };

  const fileListToArray = (list) => {
    const array = [];

    for (let i = 0; i < list.length; i++) {
      array.push(list.item(i));
    }
    return array;
  };

  const fileFormateIcon = (fileName) => {
    if (!fileName) return;
    const fileDetails = fileName.split(".");
    if (fileDetails[1] === "txt") {
      return (
        <TEXT_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (fileDetails[1] === "docx" || fileDetails[1] === "doc") {
      return (
        <WORD_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="word_icon"
        />
      );
    } else if (fileDetails[1] === "pdf") {
      return (
        <PDF_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="text_icon"
        />
      );
    } else if (
      fileDetails[1] === "xlsx" ||
      fileDetails[1] === "xls" ||
      fileDetails[1] === "ods" ||
      fileDetails[1] === "csv"
    ) {
      return (
        <EXCEL_ICON
          style="fileupload_previewList_icon"
          altText="txt"
          id="excel_icon"
        />
      );
    }
  };

  const deleteFile = (e, index) => {
    e.preventDefault();

    let fileList = [...fileListItem];
    const fileNameToDelete = fileList[index].fileName;

    fileList.splice(index, 1);

    if (fileList.length > 0) {
      setFileListItem([...fileList]);
      form.setFieldValue(name, [...fileList]);
    } else {
      setFileListItem(null);
      form.setFieldValue(name, null);
    }

    let existingFileObjectList = files ? [...files] : [];
    let newFileObjectList = existingFileObjectList.filter(
      (x) => x.name !== fileNameToDelete
    );

    if (newFileObjectList.length > 0) {
      setFiles([...newFileObjectList]);
      form.setFieldValue("filesToUploadList", [...newFileObjectList]);
    } else {
      setFiles(null);
      form.setFieldValue("filesToUploadList", null);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div
        className={`fileupload_dropzone ${
          hightlight ? "fileupload_highlight" : ""
        }`}
        onDragOver={onDragOver}
        onDragLeave={onDragLeave}
        onDrop={onDrop}
        onClick={openFileDialog}
        style={{ cursor: props.disabled ? "default" : "pointer" }}
      >
        <input
          ref={fileInputRef}
          className="fileupload_fileInput"
          type="file"
          multiple
          onChange={(e) => {
            onFilesAdded(e);
            e.target.value = "";
          }}
        />
        <div className="fileupload_iconImageWrapper">
          <UPLOAD_ICON
            style="fileupload_iconImage"
            altText="upload"
            id="upload_icon"
          />
        </div>
        <div className="fileupload_iconText">
          Drag and Drop the file to upload
        </div>
      </div>
      <input
        ref={fileBrowseRef}
        type="file"
        id="browseFile"
        style={{ display: "none" }}
        onChange={(e) => {
          onFilesAdded(e);
          e.target.value = "";
        }}
        multiple
        disabled={!!props.replaceFlag}
      />
      <button
        onClick={(e) => {
          e.preventDefault();
          fileBrowseRef.current && fileBrowseRef.current.click();
        }}
        className="fileupload_browseBtn"
      >
        Browse file
      </button>
      {fileListItem && (
        <div className="fileUpload_previewList_container">
          {fileListItem.map((file, index) => {
            if (!file.fileName) {
              return;
            }
            return (
              <div key={index}>
                {fileFormateIcon(file.fileName)}
                <span className="fileupload_previewList_filename">
                  {file.fileName}
                  <span
                    className="fileupload_previewList_deleteIcon"
                    onClick={(e) => deleteFile(e, index)}
                  >
                    X
                  </span>
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export const FormikTextField = ({
  label,
  required,
  length,
  layout,
  labelWidth,
  controlWidth,
  margin,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: margin || 0 }}>
      {layout === "Row" ? (
        <Form.Group as={Row} style={{ padding: 0, margin: "0px 0px 15px 0px" }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            <Form.Control
              {...field}
              {...props}
              isInvalid={meta.touched && meta.error}
            />

            {meta.touched && meta.error && (
              <Form.Control.Feedback type="invalid">
                {meta.error}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Form.Control
            {...field}
            {...props}
            isInvalid={meta.touched && meta.error}
          />

          {meta.touched && meta.error && (
            <Form.Control.Feedback type="invalid">
              {meta.error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </Col>
  );
};

export const FormikTextAreaField = ({ label, required, length, ...props }) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      <Form.Group style={{ padding: 0, margin: 5 }}>
        {label && (
          <Form.Label>
            {label}
            {required && <span className="required">*</span>}
          </Form.Label>
        )}
        <Form.Control
          {...field}
          {...props}
          isInvalid={meta.touched && meta.error}
        />
        {meta.touched && meta.error && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </Col>
  );
};

export const FormikSelectField = ({
  label,
  required,
  length,
  selectOptions,
  placeholder,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      <Form.Group style={{ padding: 0, margin: 5 }}>
        {label && (
          <Form.Label>
            {label}
            {required && <span className="required">*</span>}
          </Form.Label>
        )}
        <Form.Control
          {...field}
          {...props}
          isInvalid={meta.touched && meta.error}
          defaultValue=""
        >
          <option value="" disabled>
            {placeholder ? placeholder : "Select..."}
          </option>
          {selectOptions.map(({ optionValue, optionName, disabled }, i) => (
            <option
              key={optionValue}
              value={optionValue}
              disabled={disabled ? true : false}
            >
              {optionName}
            </option>
          ))}
        </Form.Control>
        {meta.touched && meta.error && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </Col>
  );
};

export const FormikMultiSelectField = ({
  label,
  layout,
  required,
  length,
  selectOptions,
  placeholder,
  labelWidth,
  controlWidth,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      {layout === "Row" ? (
        <Form.Group as={Row} style={{ padding: 0, margin: "0px 0px 15px 0px" }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            <Field
              name={props.name}
              component={MultiSelectField}
              options={selectOptions}
              meta={meta}
            />

            {meta.touched && meta.error && (
              <Form.Control.Feedback
                type="invalid"
                style={{ display: "revert" }}
              >
                {meta.error}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Field
            name={props.name}
            component={MultiSelectField}
            options={selectOptions}
          />
          {meta.touched && meta.error && (
            <Form.Control.Feedback type="invalid" style={{ display: "revert" }}>
              {meta.error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </Col>
  );
};

export const FormikPlainTextField = ({
  label,
  length,
  layout,
  labelWidth,
  controlWidth,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      {layout === "Row" ? (
        <Form.Group as={Row} style={{ padding: 0, margin: "0px 0px 5px 0px" }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            <Form.Control plaintext readOnly {...field} {...props} />
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && <Form.Label>{label}</Form.Label>}
          <Form.Control plaintext readOnly {...field} {...props} />
        </Form.Group>
      )}
    </Col>
  );
};

export const FormikRadioField = ({
  label,
  required,
  length,
  selectOptions,
  layout,
  labelWidth,
  controlWidth,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      {layout === "Row" ? (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            {selectOptions.map(({ optionValue, optionName, disabled }, i) => (
              <Form.Check
                inline
                key={i}
                disabled={disabled ? true : false}
                {...field}
                {...props}
                label={optionName}
                value={optionValue}
                checked={optionValue === meta.value.toString()}
              />
            ))}

            {meta.touched && meta.error && (
              <Form.Control.Feedback type="invalid">
                {meta.error}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          {selectOptions.map(({ optionValue, optionName, disabled }, i) => (
            <Form.Check
              key={i}
              disabled={disabled ? true : false}
              {...field}
              {...props}
              label={optionName}
              value={optionValue}
              checked={optionValue === meta.value.toString()}
            />
          ))}
          {meta.touched && meta.error && (
            <Form.Control.Feedback type="invalid">
              {meta.error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </Col>
  );
};

export const FormikCheckBoxField = ({
  label,
  length,
  selectOptions,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Col xs={6} style={{ paddingTop: "33px", margin: 0 }}>
      <Form.Group style={{ padding: 0, margin: 5 }}>
        {label && <Form.Label>{label}</Form.Label>}
        <Form.Check
          {...field}
          {...props}
          label={props.optionName}
          value={meta.value}
          checked={meta.value}
        />
        {meta.touched && meta.error && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </Col>
  );
};

export const FormikRichTextField = ({
  label,
  layout,
  required,
  length,
  selectOptions,
  placeholder,
  labelWidth,
  controlWidth,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);
  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      {layout === "Row" ? (
        <Form.Group as={Row} style={{ padding: 0, margin: "0px 0px 15px 0px" }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            <div
              className="edit_toolbar_container"
              style={
                meta.touched && meta.error
                  ? { border: "1px solid #dc3545", borderRadius: 4 }
                  : { border: "1px solid #f2f2f2" }
              }
            >
              <Field name={props.name} component={RichTextField} meta={meta} />
            </div>
            {meta.touched && meta.error && (
              <Form.Control.Feedback
                type="invalid"
                style={{ display: "revert" }}
              >
                {meta.error}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <div
            style={
              meta.touched && meta.error
                ? { border: "1px solid #dc3545", borderRadius: 4 }
                : { border: "1px solid #f2f2f2" }
            }
          >
            <Field name={props.name} component={RichTextField} />
          </div>
          {meta.touched && meta.error && (
            <Form.Control.Feedback type="invalid">
              {meta.error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </Col>
  );
};

export const FormikFileUploadField = ({
  label,
  layout,
  required,
  length,
  selectOptions,
  placeholder,
  labelWidth,
  controlWidth,
  ...props
}) => {
  const [field, meta, helpers] = useField(props);

  return (
    <Col xs={length || 12} style={{ padding: 0, margin: 0 }}>
      {layout === "Row" ? (
        <Form.Group as={Row} style={{ padding: 0, margin: "0px 0px 15px 0px" }}>
          {label && (
            <Form.Label column xs={labelWidth}>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Col xs={controlWidth}>
            <Field name={props.name} component={FileUploadControl} />

            {meta.touched && meta.error && (
              <Form.Control.Feedback type="invalid">
                {meta.error}
              </Form.Control.Feedback>
            )}
          </Col>
        </Form.Group>
      ) : (
        <Form.Group style={{ padding: 0, margin: 5 }}>
          {label && (
            <Form.Label>
              {label}
              {required && <span className="required">*</span>}
            </Form.Label>
          )}
          <Field name={props.name} component={FileUploadControl} />
          {meta.touched && meta.error && (
            <Form.Control.Feedback type="invalid">
              {meta.error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </Col>
  );
};

export const getFormFields = (formConfigList) => {
  let fieldList = [];
  formConfigList.forEach(({ validation, ...rest }) => {
    if (rest.type === "text") {
      fieldList.push(<FormikTextField {...rest} />);
    }
    if (rest.type === "plainText") {
      fieldList.push(<FormikPlainTextField {...rest} />);
    }
    if (rest.type === "select") {
      fieldList.push(<FormikSelectField as="select" {...rest} />);
    }
    if (rest.type === "textarea") {
      fieldList.push(<FormikTextAreaField as="textarea" {...rest} />);
    }
    if (rest.type === "multiSelect") {
      fieldList.push(<FormikMultiSelectField {...rest} />);
    }
    if (rest.type === "radio") {
      fieldList.push(<FormikRadioField {...rest} />);
    }
    if (rest.type === "richText") {
      fieldList.push(<FormikRichTextField {...rest} />);
    }
    if (rest.type === "fileUpload") {
      fieldList.push(<FormikFileUploadField {...rest} />);
    }
  });

  return fieldList;
};

export const getInitialFormValues = (list) => {
  let initialFormValues = {};
  if (list && list.length > 0) {
    list.forEach((item) => {
      initialFormValues[item.name] = item.initialValue || "";
    });
  }
  return initialFormValues;
};

export const getFormValidations = (list) => {
  let validations = {};
  if (list && list.length > 0) {
    list.forEach((item) => {
      if (item.validation) {
        validations[item.name] = item.validation;
      }
    });
  }
  return Yup.object().shape({ ...validations });
};
